module.exports = __webpack_public_path__ + "media/pop.15b0efd7.mp3";